<template>
  <div
    :class="['BaseToast', type]"
    @mouseenter="$emit('pause')"
    @mouseleave="$emit('resume')"
  >
    <i :class="`icon-${type}`" />

    <p>{{ te(message) ? t(message) : message }}</p>

    <i
      class="icon-close-01"
      @click="$emit('close')"
    />
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

const { t, te } = useI18n()

defineProps<{ type: string; message: string }>()
defineEmits(['close', 'pause', 'resume'])
</script>

<style lang="scss" scoped>
.BaseToast {
  display: flex;
  align-items: center;
  gap: $gap-l;
  font-size: $font-size-s;
  padding: $spacing-l;
  margin: 0;

  i {
    font-size: $font-size-2xl;

    &.icon-close-01 {
      font-size: $font-size-2xs;
      cursor: pointer;
      align-self: flex-start;
      margin-left: auto;

      @include breakpoint-md {
        align-self: unset;
      }
    }
  }

  &.success {
    background-color: $color-success-200;
    color: $color-neutral-dark;

    i {
      color: $color-success;

      &:first-child::before {
        content: var(--icon-correcto);
      }
    }
  }

  &.error {
    background-color: $color-error-200;
    color: $color-neutral-dark;

    i {
      color: $color-secondary;

      &:first-child::before {
        content: var(--icon-incorrecto);
      }
    }
  }

  &.info {
    background-color: $color-primary-lighter;
    color: $color-neutral-dark;

    i :first-child {
      color: $color-primary;

      &:first-child::before {
        content: var(--icon-informacion);
      }
    }
  }

  &.warning {
    background-color: $color-warning-200;
    color: $color-neutral-dark;

    i {
      color: $color-warning-700;

      &:first-child::before {
        content: var(--icon-minus-03);
      }
    }
  }
}
</style>
